<template>
  <div class="readBox">
    <div class="toplogo" @click="gohome">
      <img :src="puyue" alt="">
    </div>
    <div class="topNav">
      <a href="http://www.pengzushijia.com" class="span_nav" target="_blank">平台导航</a>
      <a href="http://maker.pengzushijia.com/project/allDataBase" class="span_nav" target="_blank">总数据库</a>
      <a href="http://maker.pengzushijia.com" class="span_nav" target="_blank">编纂平台</a>
      <!--<a href="http://admin.pengzushijia.com" class="span_nav" target="_blank">管理平台</a>-->
      <a href="/home" target="_blank" class="span_nav" style="font-weight: bold;font-size: 16px;margin-left: 10px">门户首页</a>
    </div>
    <div v-if="noRead" class="centerBox">
      <div class="leftShow">
        <div class="tipname" />
        <div v-if="code===0" class="tipname_text">
          完全公开
        </div>
        <div v-if="code===-1" class="tipname_text">
          无权限
        </div>
        <div v-if="code===1" class="tipname_text">
          密码查看
        </div>
        <div v-if="code===2" class="tipname_text">
          付费查看
        </div>
        <div class="imgBox">
          <img v-if="type==1" :src="currentData.BOOK_LOGO_IMG" alt="">
          <img v-if="type==2" :src="puwendefault" alt="">
          <img v-if="type==3" :src="puxidefault" alt="">
          <img v-if="type==4" :src="puxidefault" alt="">
        </div>
        <p class="names">
          {{ currentData.RES_NAME }}
        </p>
        <div class="usermsg">
          <div class="imguser">
            <img v-if="currentData.RES_PHOTO" :src="currentData.RES_PHOTO" alt="">
            <img v-else :src="user" alt="">
          </div>
          <div class="username">
            {{ currentData.NICKNAME }}
          </div>
        </div>
      </div>
      <div class="rightShow">
        <div class="topcode">
          <img :src="topcode" alt="">
          <div class="codebox">
            <img :src="srcUrl" alt="">
            <span>微信扫码  手机查阅&转发分享</span>
          </div>
        </div>
        <div class="toptitlemsg">
          <img :src="toptitlemsg" alt="">
        </div>
        <!--完全公开-->
        <div v-if="code===0">
          <div class="toptitle">
            完全公开
          </div>
          <div class="topmsg">
            该资源完全公开，可直接查看
          </div>
          <div class="chakanBtn" @click="goread">
            立即查看
          </div>
        </div>
        <!--无查看权限-->
        <div v-if="code===-1">
          <div class="toptitle">
            无权限
          </div>
          <div class="topmsg">
            该资源完全保密，不公开
          </div>
          <div class="nopurview">
            <img :src="nopurview" alt="">
            <p>您没有权限访问</p>
          </div>
        </div>
        <div v-if="code===2">
          <div class="toptitle">
            付费查阅
          </div>
          <div class="topmsg">
            支付完￥{{ moneny }}后即可随时查阅
          </div>
          <div class="paycodeImg">
            <div id="qrcode_pay_read" />
            <p style="margin-top: 20px;">
              <span style="border-radius: 50%;display:inline-block;width: 19px;height: 19px;background-color: #00C103;"><svg-icon icon-class="wx" /></span>使用微信扫码付款后查看
            </p>
          </div>
        </div>
        <div v-if="code===1">
          <div class="toptitle">
            密码查看
          </div>
          <div class="topmsg">
            输入密码后可立即查阅
          </div>
          <div class="inputBox">
            <div style="text-align: left;width: 320px;display: inline-block;margin-left: 10px;margin-bottom: 10px">
              请输入密码:
            </div>
            <div class="inputcontent">
              <input v-model="pwd" type="password" class="input_pwd">
            </div>
            <div class="checkBtn" @click="goread">
              进入阅读
            </div>
          </div>
          <div v-show="error.iserror" class="errStyle">
            {{ error.msg }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="!noRead&&isload" class="noreadBox">
      {{ messages }}
    </div>
    <div class="foots">
      <div>©2019彭祖世家网·《彭祖世家总谱·事典》总谱官网及门户网站 Pengzushijia.COM 彭祖世家文化发展有限公司 <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #999999;">粤ICP备19063974号</a> 技术支持：武汉聚脉网络科技有限公司</div>
      <!--<div>GB/T29490-2013知识产权管理体系认证证书编号：165IP194386ROS     联系邮箱：contactus@jointat.com</div>-->
    </div>
  </div>
</template>
<script>
import { getResIsTrue, getResPassworld, getResNewIsAll, getWeChatQr, resAccessPermissions, startPayRulePc, verificationReaderOrder } from '@/api/api.js'
export default {
  // components: {  },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: this.currentData.RES_NAME,
      mateDesc: metaStr
    }
  },
  data() {
    return {
      timer: null,
      moneny: '',
      codeUrl: '',
      puyueCode: require('@/static/readerCode.png'),
      fmsCode: require('@/static/familyspaceCode.png'),
      srcUrl: '',
      messages: '该资源未发布，暂不支持查看',
      isload: false,
      noRead: false,
      user: require('@/static/user.png'),
      puwendefault: require('@/static/puwendefault.jpg'),
      puxidefault: require('@/static/puxidefault.jpg'),
      puyue: require('@/static/readCheck_logo.png'),
      nopurview: require('@/static/allowread_no.png'),
      topcode: require('@/static/rightcode.png'),
      toptitlemsg: require('@/static/topmsg.png'),
      paycode: require('@/static/paycode.png'),
      code: '',
      pwd: '',
      currentData: '',
      listData: '',
      type: '',
      allowRead: false,
      error: {
        iserror: false,
        msg: ''
      }
    }
  },
  created() {

  },
  mounted() {
    localStorage.removeItem('isback')
    // this.$router.go(-1)
    // if (!) {
    //   this.$router.push({ path: '/home' })
    // }
    if (this.getLoca('userid')) {
      resAccessPermissions({ userId: this.getLoca('readerUsrId'), resId: this.$route.query.id }).then(res => {
        if (res.data) {
          this.noRead = true
          this.allowRead = true
          this.code = 0
        } else {
          getResIsTrue({ resId: this.$route.query.id, resType: this.$route.query.type }).then(res => {
            this.code = res.data.code
            if (res.data.code == 3 || res.data.code == 4) {
              if (res.data.code == 3) {
                this.messages = '该资源未被发布或被撤回'
              }
              // this.$message({
              //   type: 'error',
              //   message: '服务器错误请稍后再试'
              // })
              this.noRead = false
            } else {
              this.noRead = true
            }
            this.isload = true
            if (this.code === 0) {
              this.allowRead = true
            }
            if (this.code === 2) {
              this.allowRead = true
              startPayRulePc({ userId: this.getLoca('readerUsrId'), resId: this.$route.query.id }).then(res => {
                this.getCode(res.data.url)
                this.moneny = res.data.money
                if (this.timer) {
                  clearInterval(this.timer)
                }
                this.checkPay(res.data.orderid)
                this.timer = setInterval(() => {
                  this.checkPay(res.data.orderid)
                }, 60000)
              })
            }
          })
        }
      })
    } else {
      // //////未登录直接跳转去登录
      this.setloca('isback', window.location.href, 7200)
      this.$router.push('/login')
    }
    this.type = this.$route.query.type
    // /谱阅二维码
    getResNewIsAll({ resId: this.$route.query.id, resType: this.type }).then(res => {
      this.currentData = res.data
      var type = this.$route.query.type
      if (type == 4) {
        type = 3
      }
      if (type == 5 || type == 6) {
        type = 1
      }
      this.srcUrl = 'http://admin.myfamilybook.cn/jointat-mfb-admin/portalBook/getWeChatQr?resId=' + res.data.RES_ID + '&type=' + type
    })
    this.fn()
  },
  methods: {
    getCode(url) {
      const qrcodepay = new QRCode('qrcode_pay_read', {
        text: url,
        width: 200,
        height: 200,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcodepay.clear()
      qrcodepay.makeCode(url)// 生成另一个新的二维码
    },
    checkPay(orderid) {
      verificationReaderOrder({ orderid: orderid }).then(res2 => {
        if (res2.data) {
          this.code = 0
          this.$message({
            type: 'success',
            message: '支付成功'
          })
        }
      })
    },
    gohome() {
      this.$router.push({ path: '/home' })
    },
    fn: function() {
      window.scrollTo(0, 0)
    },
    goread: function() {
      var baseurl = 'http://maker.pengzushijia.com/'
      if (this.systemConfig.systemConfig.isMFB) {
        baseurl = 'http://maker.myfamilybook.cn/'
      }
      if (this.code == 1) {
        this.error.iserror = false
        getResPassworld({ resId: this.currentData.RES_ID, password: this.pwd }).then(res => {
          if (res.data.code) {
            var url = ''
            if (this.type == 1 || this.type == 5 || this.type == 6) {
              if (this.currentData.BOOK_TYPE == 2) {
                url = baseurl + 'book/previewEbookActionTemporary/' + this.$route.query.id
              } else {
                url = baseurl + 'book/previewActionTemporary/' + this.$route.query.id
              }
            }
            if (this.type == 2) {
              url = baseurl + 'article/previewActionTemporary/' + this.$route.query.id
            }
            if (this.type == 3) {
              url = baseurl + 'tree/previewThinkTreeTemporary/' + this.$route.query.id
            }
            if (this.type == 4) {
              url = baseurl + 'tree/previewThinkTreeTemporary/' + this.currentData.RES_ID + '?nodeId=' + this.$route.query.id
            }
            window.open(url, '_blank')
          } else {
            this.error.iserror = true
            this.error.msg = '密码错误，请重试'
          }
        })
      }
      if (this.allowRead) {
        var url = ''
        if (this.type == 1 || this.type == 5 || this.type == 6) {
          if (this.currentData.BOOK_TYPE == '2') {
            url = baseurl + 'book/previewEbookActionTemporary/' + this.$route.query.id
          } else {
            url = baseurl + 'book/previewActionTemporary/' + this.$route.query.id
          }
        }
        if (this.type == 2) {
          url = baseurl + 'article/previewActionTemporary/' + this.$route.query.id
        }
        if (this.type == 3) {
          url = baseurl + 'tree/previewThinkTreeTemporary/' + this.$route.query.id
        }
        if (this.type == 4) {
          url = baseurl + 'tree/previewThinkTreeTemporary/' + this.currentData.RES_ID + '?nodeId=' + this.$route.query.id
        }
        window.open(url, '_blank')
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  #qrcode_pay_read{
    display: inline-block;
  }
  .puyueCode{
    width: 179px;
    /*height: 213px;*/
    position: absolute;
    top: 26px;
    left: -54px;
    z-index: 99;
    transition: 0.3s;
    height: 0;
  }
  .fmsCode{
    width: 179px;
    /*height: 213px;*/
    position: absolute;
    top: 26px;
    left: -48px;
    z-index: 99;
    transition: 0.3s;
    height: 0;
  }
  .fms:hover >.fmsCode{
    height: 213px;
  }
  .puyue:hover >.puyueCode{
    height: 213px;
  }
  .noreadBox{
    font-size: 30px;
    color: #ccc;
    cursor:not-allowed
  }
  .errStyle{
    text-align: center;
    font-size: 14px;
    color: #ed4040;
    margin-top: 20px;
  }
  .topNav{
    position: absolute;
    top: 40px;
    right: 50px;
    width: 510px;
    height: 40px;
    font-size: 0;
    .span_nav{
      width: 85px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      display: inline-block;
      font-size: 16px;
      color: #333333;
      &:hover{
        color: #ed4040;
      }
    }
  }
    .readBox{
        width: 100%;
        height: 100vh;
        max-height: 100vh;
        background-color: #F7F4EE;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        display:flex;
        justify-content: center;
        align-items: center;
        .toplogo{
          cursor: pointer;
            width: 205px;
            height: 55px;
            position: absolute;
            top: 40px;
            left: 56px;
            font-size: 0;
            img{
                width: 205px;
                height: 55px;
            }
        }
        .centerBox{
            height: 530px;
            width: 905px;
            background-color: #fff;
            -moz-box-shadow:2px 2px 5px 2px #E5E5E5;
            -webkit-box-shadow:2px 2px 5px 2px #E5E5E5;
            box-shadow:2px 2px 5px 2px #E5E5E5;
        }
        .leftShow{
            display: inline-block;
            width: 435px;
            height: 530px;
            float: left;
            position: relative;
            background-color: #F4F0E7;
            .tipname{
                display: inline-block;
                width: 51px;
                height: 0;
                border-width: 0 35px 35px 35px;
                border-style: none solid solid;
                border-color: transparent transparent #E3003A;
                transform: rotate(-45deg);
                position: absolute;
                top: 83px;
                left: 75px;
            }
            .tipname_text{
                position: absolute;
                width: 80px;
                text-align: center;
                transform: rotate(-45deg);
                top: 90px;
                color: #ffffff;
                left: 94px;
            }
            .imgBox{
                width: 220px;
                height: 300px;
                display: inline-block;
                margin-left: 105px;
                margin-top: 70px;
                font-size: 0;
                img{
                    width: 220px;
                    height: 300px;
                }
            }
            .names{
                text-align: center;
                font-size: 23px;
                font-weight: 600;
                color: #131313;
                margin-top: 20px;
                height: 30px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
            .usermsg{
                height: 25px;
                margin-top: 15px;
                width: 100%;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                .imguser{
                    display: inline-block;
                    width: 25px;
                    height: 25px;
                    img{
                        width: 25px;
                        height: 25px;
                        border-radius: 50%;
                    }
                }
                .username{
                    font-size: 12px;
                    display: inline-block;
                    vertical-align: top;
                    height: 25px;
                    line-height: 25px;
                    margin-left: 10px;
                }
            }
        }
        .rightShow{
            text-align: center;
            display: inline-block;
            width: 470px;
            height: 530px;
            float: left;
            position: relative;
            overflow: hidden;
            .topcode{
                position: absolute;
                width: 51px;
                height: 51px;
                top: 3px;
                right: 3px;
              cursor: pointer;
                img{
                    width: 51px;
                    height: 51px;
                }
              .codebox{
                transition: 1s;
                width: 470px;
                height: 530px;
                position: absolute;
                top: -533px;
                left: -416px;
                background-color: #fff;
                z-index: 99999;
                img{
                  width: 200px;
                  height: 200px;
                  margin-top: 130px;
                }
                span{
                  display: inline-block;
                  line-height: 20px;
                  height: 20px;
                  width: 470px;
                  color: #ccc;
                  font-size: 16px;
                  margin-top: 20px;
                }
              }
              &:hover > .codebox{
                top: 0;
              }
            }
            .toptitlemsg{
                width: 167px;
                height: 32px;
                position: absolute;
                top: 3px;
                right: 56px;
                img{
                    width: 167px;
                    height: 32px;
                }
            }
            .toptitle{
                font-size: 25px;
                font-weight: 500;
                color: #333333;
                text-align: center;
                margin-top: 100px;
            }
            .topmsg{
                font-size: 14px;
                color: #999999;
                text-align: center;
                margin-top: 15px;
            }
            .paycodeImg{
                margin-top: 50px;
                img{
                    width: 191px;
                    height: 192px;
                }
                svg{
                    color: #ffffff;
                }
            }
            .inputBox{
                text-align: center;
                margin-top: 80px;
                .inputcontent{
                    display: inline-block;
                    width: 230px;
                    text-align: left;
                    font-size: 0;
                    .input_pwd{
                        height: 40px;
                        border: 1px solid #E9E3D6;
                        width: 228px;
                        text-indent: 15px;
                        font-size: 28px;
                    }
                }
                .checkBtn{
                    display: inline-block;
                    vertical-align: top;
                    width: 75px;
                    height: 42px;
                    background-color: #E3003A;
                    color: #ffffff;
                    text-align: center;
                    line-height: 42px;
                    font-size: 14px;
                    margin-left: 15px;
                    cursor: pointer;
                }
            }
            .nopurview{
                margin-top: 50px;
                display: inline-block;
                width: 173px;
                height: 193px;
                font-size: 0;
                img{
                    width: 173px;
                    height: 153px;
                }
                p{
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 14px;
                    color: #808080;
                }
            }
            .chakanBtn{
                cursor: pointer;
                display: inline-block;
                width: 140px;
                height: 40px;
                color: #ffffff;
                background-color: #E3003A;
                font-size: 14px;
                text-align: center;
                line-height: 40px;
                margin-top: 100px;
            }
        }
        .foots{
            position: absolute;
            bottom: 40px;
            font-size: 14px;
            color: #999999;
            text-align: center;
        }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {

    }
</style>
